import { useSelector } from "react-redux";
import { RootState } from "../Redux/Reducers";
import { STAFF_PERMISSION_TYPE } from "../Constants";
import { useEffect, useState } from "react";

export function useStaffPermission() {
  const { staffMemberPermissions }: any = useSelector((state: RootState) => ({
    staffMemberPermissions: state.staffManagementReducer.staffMemberData?.permissions,
  }));

  const [state, setState] = useState({
    isStaffMemberDetailsAvailable: false,
    staffMemberPermissions: [],
    canManageOrders: false,
    canManageCatalog: false,
    canManageSettingAndPromo: false,
    canManageMarketing: false,
    canManageSubscriptions: false,
  });

  useEffect(() => {
    const isStaffMemberDetailsAvailable = Array.isArray(staffMemberPermissions);
    setState({
      isStaffMemberDetailsAvailable,
      staffMemberPermissions: isStaffMemberDetailsAvailable ? staffMemberPermissions : [],
      canManageOrders: !!staffMemberPermissions?.includes?.(STAFF_PERMISSION_TYPE.ORDERS),
      canManageCatalog: !!staffMemberPermissions?.includes?.(STAFF_PERMISSION_TYPE.CATALOG),
      canManageSettingAndPromo: !!staffMemberPermissions?.includes?.(STAFF_PERMISSION_TYPE.SETTINGS),
      canManageMarketing: !!staffMemberPermissions?.includes?.(STAFF_PERMISSION_TYPE.MARKETING),
      canManageSubscriptions: !!staffMemberPermissions?.includes?.(STAFF_PERMISSION_TYPE.SUBSCRIPTION),
    });
  }, [staffMemberPermissions]);

  return state;
}
